<template>
    <div class="form-group">
        <label :for="getId" v-text="getLabel"></label>
        <v-select
                v-model="currentObject"
                :options="galleries"
                :loading="isLoading || booting"
                label="name"
                ref="selector"
        >
        </v-select>
    </div>
</template>

<script>
    import fieldInfo from './../mixins/fieldInfo';
    import vSelect from 'vue-select';

    export default {
        components: {
            vSelect
        },
        mixins: [
            fieldInfo,
        ],
        data: function () {
            return {
                booting: true,
                currentObject: null,
            }
        },
        computed: {
            galleries() {
                return this.$store.state.composer.galleries;
            },
            isLoading() {
                return this.$store.getters.isLoading('galleries');
            }
        },
        methods: {
            setObject(gallery) {
                this.currentValue = gallery.id;
                this.booting = false;
            }
        },
        watch: {
            currentObject(newValue, oldValue) {
                if (newValue !== oldValue && newValue !== undefined && newValue !== null && newValue !== '') {
                    this.setObject(newValue);
                }
            }
        },
        created() {
            this.$store.dispatch('boot', 'getGalleries').then(() => {
                this.booting = false;
                this.currentObject = this.currentValue;
            });
        }
    }
</script>

<style scoped>

</style>
